import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { formatNumber, formatPercent, safeText } from "./principle6SheetHelpers.js";

export const SHEET_NAME = "Project for rehabilitation";

const SHEET_TITLE =
  "Provide information on project(s) for which ongoing Rehabilitation and Resettlement (R&R) is being undertaken by your entity, in the following format";

const WIDTHS = {
  A: 1.26953125,
  B: 1.26953125,
  C: 9.1796875,
  D: 6.26953125,
  E: 44.26953125,
  F: 32.54296875,
  G: 21.54296875,
  H: 30.7265625,
  I: 22.1796875,
  J: 32.54296875,
  K: 9.1796875,
  L: 9.1796875,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_J;
const ALL_THIN = Array(7).fill("tttt");

export function buildProjectForRehabilitationSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 11,
    topLeftCell: "D12",
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 12);
  ws.views[0].zoomScale = 85;
  ws.views[0].zoomScaleNormal = 85;

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, {
    height: 30,
    borderPatterns: ALL_THIN,
  });

  applyBorderPattern(ws, HEADER_ROW, COL_D, ALL_THIN);
  ws.getRow(HEADER_ROW).height = 29;
  [
    { col: COL_D, label: "Sr.\nNo." },
    { col: COL_E, label: "Name of Project for which R&R is ongoing" },
    { col: COL_F, label: "State" },
    { col: COL_G, label: "District" },
    { col: COL_H, label: "No. of Project Affected Families (PAFs)" },
    { col: COL_I, label: "% of PAFs covered by R&R" },
    { col: COL_J, label: "Amounts paid to PAFs in the FY (In INR)" },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ALL_THIN);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, COL_END, { row: SPACER_ROW, height: 30, patterns: ALL_THIN });

  const rows = sectionC?.principle8?.essentialIndicators?.rehabilitationAndResettlement || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        {
          col: COL_E,
          value: safeText(item?.projectName, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_F,
          value: safeText(item?.state, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_G,
          value: safeText(item?.district, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_H,
          value: formatNumber(item?.numberOfProjectAffectedFamilies),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_I,
          value: formatPercent(item?.percentagePAFsCoveredByRR),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_J,
          value: formatNumber(item?.amountsPaidToPAFs),
          align: "center",
          fill: VALUE_FILL,
        },
      ],
      { patterns: ALL_THIN }
    );
  });

  return ws;
}
